<template>
  <div>
    <span id="license-restriction-reason" class="license-restriction-reason">{{ restrictionReason }}</span>
    <span id="license-report-generate-reason" class="license-restriction-reason">{{ $t('license.restricted.report_generate') }}</span>
    <v-snackbar
      v-if="notice"
      :value="true"
      :timeout="notice && notice.type === 'restored' ? 5000 : 0"
      bottom
      left
      color="warning"
      :data-test="notice && notice.type === 'restored' ? 'license-restored-notice' : 'license-restricted-notice'"
    >
      <span>{{ message }}</span>
      <v-btn flat @click="clearLicenseRestriction">{{ $t('common.close') }}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({ notice: 'getLicenseRestrictionNotice' }),
    message() {
      if (!this.notice) return ''
      if (this.notice.type === 'restored') return this.$t('license.restored')
      const messageKeys = {
        'clinical.write': 'clinical_write',
        'report.generate': 'report_generate',
        'history.read': 'history_read',
        'history.print': 'history_print',
      }
      return this.$t(`license.restricted.${messageKeys[this.notice.capability] || 'clinical_write'}`)
    },
    restrictionReason() { return this.$t('license.restricted.clinical_write') },
  },
  methods: mapActions(['clearLicenseRestriction']),
}
</script>

<style scoped>
.license-restriction-reason {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
